<template>
    <t-modal v-model="isVisible" @closed="onModalClosed">
        <span>
            <h2>Upload new image for your {{ modalType }}</h2>
        </span>
        <span>
            <p class="mt-5" v-if="modalType == 'avatar'">
                Please use a square image for best look on avatar. We suggest a
                200px by 200px image.
            </p>
            <p class="mt-5" v-if="modalType == 'banner'">
                We suggest using a 1480px by 200px image for your banner.
            </p>
            <p>File format must be one of the following: PNG, JPG or HEIC (Apple iDevice)</p>
        </span>
        <ValidationObserver v-slot="{ invalid }" ref="observer">
            <form @submit.prevent="onSubmitUpload">
                <div class="flex flex-col mt-5 justify-between">
                    <ValidationProvider
                        class="flex flex-col"
                        rules="required"
                        v-slot="{ classes, errors }"
                    >
                        <input
                            @change="fileChanged"
                            :classes="classes"
                            type="file"
                            accept="image/png, image/jpeg, image/heic"
                        />
                        <span class="text-red-500 text-hint">{{
                            errors[0]
                        }}</span>
                    </ValidationProvider>
                    <button
                        class="w-1/3 mr-8 mt-6 primary-btn md:px-14 px-4"
                        type="submit"
                        :disabled="invalid || isDisabled"
                    >
                        Submit
                    </button>
                </div>
            </form>
        </ValidationObserver>
        <t-alert variant="danger" :show="showError" class="mt-3" @hidden="showError = false">
            {{ errorMessage }}
        </t-alert>
    </t-modal>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
export default {
    props: ["modalVisible", "modalType"],
    data() {
        return {
            isVisible: this.modalVisible,
            showError: false,
            errorMessage:
                "There was an error uploading file. Make sure it is the proper size and type.",
            selectedFile: null,
            isDisabled: true,
        };
    },
    methods: {
        onModalClosed() {
            this.showError = false;
            this.errorMessage = "";
            this.selectedFile = null;
            this.$emit("uploadModalClosed");
        },
        onSubmitUpload() {
            const formData = new FormData();
            formData.append("document", this.selectedFile);
            formData.append("function", this.modalType);
            axios
                .post("/api/user/documents/create", formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                })
                .then((response) => {
                    if (response.data.success) {
                        window.location.reload();
                    }
                })
                .catch((error) => {
                    console.log( 'upload modal error')
                    this.showError = true;
                });
        },
        fileChanged(e) {
            this.selectedFile = e.target.files[0];
            if(e.target.files[0]['type'] == 'image/jpeg' || e.target.files[0]['type'] == 'image/png' || e.target.files[0]['type'] == 'image/heic'){
                this.isDisabled = false;
                return;
            }
            this.showError = true;
            this.isDisabled = true;
        },
    },
    watch: {
        modalVisible() {
            if (this.isVisible !== this.modalVisible) {
                this.isVisible = this.modalVisible;
            }
        },
    },
    components: {
        ValidationObserver,
        ValidationProvider,
    },
};
</script>
